module.exports = __webpack_public_path__ + "static/media/tiktok_logo_icon.6218b5ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiktok_logo_icon.svg
// module id = 141
// module chunks = 0